import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import OnboardingTemplate from '../OnboardingTemplate';
import { ONBOARDING_STEP_ORDER } from './constants';
import { StepWrap } from './shared/shared.styles';
import OnboardingStep3 from './OnboardingStep3';
import OnboardingStep4 from './OnboardingStep4';
import { AuthContext } from '../../../Context/authContext';

function OnBoarding() {
  const [step, setStep] = useState('setup');
  const [data, setData] = useState({
    business: null,
    role: null,
    goal: null,
  });
  const navigate = useNavigate();
  const { getPermissions } = useContextHook(AuthContext, v => ({
    getPermissions: v.getPermissions,
  }));

  const next = () => {
    const index = ONBOARDING_STEP_ORDER.indexOf(step);
    setStep(ONBOARDING_STEP_ORDER[Math.min(index + 1, ONBOARDING_STEP_ORDER.length - 1)]);
  };

  const handlePrepareDone = () => {
    navigate('/ai-onboarding');
    getPermissions();
  };

  const showRightPanel = step !== 'prepare';

  return (
    <OnboardingTemplate showRightPanel={showRightPanel}>
      {step === 'setup' && (
        <StepWrap key="setup">
          <OnboardingStep3
            data={data}
            onNext={values => {
              setData(prev => ({ ...prev, ...values }));
              next();
            }}
          />
        </StepWrap>
      )}

      {step === 'prepare' && (
        <StepWrap key="prepare">
          <OnboardingStep4 data={data} onDone={handlePrepareDone} />
        </StepWrap>
      )}
    </OnboardingTemplate>
  );
}

export default OnBoarding;
